/**
 * <s-gallery-thumbs> scrolls its target gallery to the media a thumbnail points at,
 * and marks the thumbnail of the slide in view. Thumbnails are plain links
 * (href="#media-id"), so without JavaScript they still jump to the slide.
 */
class SGalleryThumbs extends HTMLElement {
  #ac;
  #observer;

  connectedCallback() {
    this.#ac = new AbortController();
    const gallery = document.getElementById(this.getAttribute('for') || '');
    if (!gallery) return;

    this.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
      if (!link) return;
      const slide = gallery.querySelector(link.getAttribute('href'));
      if (!slide) return;
      event.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }, { signal: this.#ac.signal });

    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        for (const link of this.querySelectorAll('a[href^="#"]')) {
          const current = link.getAttribute('href') === `#${entry.target.id}`;
          if (current) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        }
      }
    }, { root: gallery, threshold: 0.6 });
    for (const slide of gallery.querySelectorAll('[data-gallery-slide]')) this.#observer.observe(slide);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-gallery-thumbs')) customElements.define('s-gallery-thumbs', SGalleryThumbs);
